<template>
  <div>
    <v-navigation-drawer
      :clipped="$vuetify.breakpoint.lgAndUp"
      v-model="drawer"
      fixed
      app
    >
      <v-list dense>
        <template v-for="item in items">
          <v-layout
            v-if="item.heading"
            :key="item.heading"
            row
            align-center
          >
            <v-flex xs6>
              <v-subheader v-if="item.heading">
                {{ item.heading }}
              </v-subheader>
            </v-flex>
            <v-flex xs6 class="text-xs-center">
              <a href="#!" class="body-2 black--text">EDIT</a>
            </v-flex>
          </v-layout>
          <v-list-group
            v-else-if="item.children"
            v-model="item.model"
            :key="item.text"
            :prepend-icon="item.model ? item.icon : item['icon-alt']"
            append-icon=""
          >
            <v-list-tile slot="activator" class="nav_drop_menu">
              <v-list-tile-content>
                <v-list-tile-title>
                  {{ item.text }}
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
              v-for="(child,i) in item.children"
              :key="i"
             
            >
              <v-list-tile-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>
                  <router-link :to="{name:child.link,params: {} }" style="color:rgba(0,0,0,.87)">
                    {{ child.text }}
                  </router-link>
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list-group>
          <v-list-tile v-else :key="item.text">
            <v-list-tile-action>
              <router-link :to="{ name:item.link,params: {} }" >
              <v-icon>
                {{ item.icon }}
              </v-icon>
              </router-link>
            </v-list-tile-action>
            <router-link :to="{ name: item.link,params:{} }" style="color:rgba(0,0,0,.87)">
            <v-list-tile-content class="nav_menu">
              <v-list-tile-title>
                {{ item.text }}
              </v-list-tile-title>
            </v-list-tile-content>
            </router-link>
          </v-list-tile>
        </template>
      </v-list>
    </v-navigation-drawer>

    <v-toolbar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      class="main_color"
      dark
      app
      fixed
     >
      <v-toolbar-title  class="ml-0">
        <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
        <span class="hidden-sm-and-down">POS</span>    
      </v-toolbar-title>
      <v-text-field
        flat
        solo-inverted
        prepend-icon="search"
        label="Search"
        class="hidden-sm-and-down"
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-btn icon>
        <v-icon>apps</v-icon>
      </v-btn>
      <v-btn icon>
        <v-icon>notifications</v-icon>
      </v-btn>
    </v-toolbar>
    

    <v-toolbar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      dark
      app
      fixed
      class="admin_toolbar main_color"
     >
      <v-toolbar-title class="ml-0">
        <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
        <span class="hidden-sm-and-down">POS</span>
      </v-toolbar-title>
      
      
      <v-spacer></v-spacer>

      <!--<v-btn class="ilang" v-for="entry in languages" :key="entry.title" @click="changeLocale(entry.language)">   
               <flag :iso="entry.flag" v-bind:squared=false />  {{entry.title}}    </v-btn>-->

      <v-btn icon v-if="userLoggedin" @click="logout()">
        <v-icon>power_settings_new</v-icon>
      </v-btn>
    </v-toolbar>
  </div>
</template>

<script>
import db from '@/firebase/init'
import firebase from 'firebase'
import {i18n} from '@/plugins/i18n'
export default {
  name:'Navbar',
  data(){
      return{
        userLoggedin:false,
        drawer: null,
        languages: [            
            {flag: 'us', 
            language: 'en', 
            title: 'English' 
            },    
              
           {flag: 'pt',
           language: 'pt',
            title: 'Portuguese' 
            },
             {flag: 'tr',
           language: 'tr',
            title: 'Turkish' 
            },        
        ],
      }
  },
  methods:{
    logout(){
      firebase.auth().signOut()
      .then((user)=>{
        this.$router.replace('/')
      });
    },
    clickMethod(){
      console.log("Clicked");        
    }
    ,
      changeLocale(locale) {        
        i18n.locale = locale;   
        
        }
  },
 
  created(){
    var db = firebase.firestore();      

    var user = firebase.auth().currentUser;
    if (user) {
      this.userLoggedin = true;
    } else {
      this.userLoggedin = false;
    }

  },
  computed:{
    items () {
      return [
          { icon: 'laptop_mac', text: this.$t('POS'), link:'Pos' },
          { icon: 'dashboard', text: this.$t('Report'), link:'Dashboard' }, 
          {
          icon: 'keyboard_arrow_up',
          'icon-alt': 'card_giftcard',
          text: this.$t('Items'),
          model: false,
          children: [
            { text: 'Items', link:'Items'},
            { text: this.$t('Categories'), link:'ItemCategories' },           
          ]
          },              
          {
          icon: 'keyboard_arrow_up',
          'icon-alt': 'add_shopping_cart',
          text: this.$t('Sales'),
          model: false,
          children: [
            { text: this.$t('Sales'), link:'Sales'},
            { text: this.$t('Sales_report'), link:'SalesReport' },
          ]
          },
          {
          icon: 'keyboard_arrow_up',
          'icon-alt': 'attach_money',
          text: this.$t('Expenses'),
          model: false,
          children: [
            { text: this.$t('Expenses'), link:'Expenses'},
            { text: this.$t('Expense_type'), link:'ExpenseType'},
            { text: this.$t('Expense_report'), link:'ExpenseReport' },
          ]
          },               
          { icon: 'trending_up', text: this.$t('Chart'), link:'Report' },         
          { icon: 'settings', text: this.$t('Settings') , link:'Settings'},
          
        
    
        
        
      ]
     },
    
     
      
  }
}
</script>

<style>
  a{
    text-decoration: none;
    color: black;
  }
  .theme--light .list .list__tile--link:hover {
    background: none !important;
  }
  .ilang{    
        
  font-size: 14px;    
  margin: 15px;
  background: none !important;
  padding: 2px;
  
  }
  
</style>



// WEBPACK FOOTER //
// src/components/admin/navbar/Navbar.vue